// redirects an slug like bnnvara.nl/rubrieken/gen-z to the rubrics detail
// logics in the brandSlug Folder whithout using the [brandSlug] argument.
export { default } from '../[brandSlug]/rubrieken/[slug]';
